import script from "./invoice-apply-individual-dialog-content.vue?vue&type=script&lang=ts&setup=true"
export * from "./invoice-apply-individual-dialog-content.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__